import React from "react";
import styled from "styled-components";
import { LoadingIcon, Stack, Text } from "basis";

const WRAPPER_SPACING = "72px 24px";

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: ${WRAPPER_SPACING};
  text-align: center;
`;

export const Authorising = () => (
  <Wrapper>
    <Stack align="center" gap="12">
      <LoadingIcon size="medium" />
      <Text textStyle="heading6">
        Verifying request while you wait..
      </Text>
    </Stack>
  </Wrapper>
);

export default Authorising;
